quoteModule.factory('vehicleRateRetrievalService', ['$http','AppSettings', 'commonRESTCallService', 'erateSessionVarsService', 'rateQuoteCoordService', 'imSessionVarsService','$q',
function ($http, appSettings, commonRESTCallService, erateSessionVarsSvc, rateQuoteCoordService, imSessionVarsService,$q) {
    //wbh - 6/30/2015 :: Since this service is essentially a pass-thru to the business service
    // we are not going to create a unit test for it. The bulk of the logic is the API call

    var vehRateService = {};
    //the BIG rating call!
    // get rates for a product
    vehRateService.getRatesForProduct = function(
        dos,
        vehicle,
        odometer,
        certfication,
        usageTypes,
        vehicleInservice,
        dealInfo,
        providerSpecificInfo,
        prod,
        quoteSession,
        rvInfo
    )

    {

        var deferred = $q.defer();
        //console.log('===================================')
        //console.log(appSettings.startSPANVehicleRateSvcURL + "/RetrieveVehicleRates");
        //console.log(JSON.stringify(prod));
        //console.log('===================================')

        var partnerSpecificFields = convertToKeyValuePairs(providerSpecificInfo);
        if (rvInfo!=null){
            mapRVRatingFields(rvInfo,partnerSpecificFields);
        }
        var cust = rateQuoteCoordService.CustomerData;
        if (cust)
            mapCustomerEligibilityFields(cust, partnerSpecificFields);
        //force usage types to an array
        if (usageTypes && !angular.isArray(usageTypes)){ usageTypes = [usageTypes];}

        vehRateService.getRateRequestTemplate()
        .then(function(rateRequest){
                //set up the request object
                rateRequest.dateOfSale = dos.yyyymmdd();
                rateRequest.dealerAccountCode = erateSessionVarsSvc.getCurrentDealerAccountCode();
                rateRequest.eligibilitySessionID = null;
                rateRequest.partnerSpecificEligibility = partnerSpecificFields;
                rateRequest.productPlanType = vehicle.saleType;
                rateRequest.productsToRate = [prod];
                rateRequest.providerCode = imSessionVarsService.getCurrentProviderCode();
                rateRequest.vehicleCertification = certfication;
                rateRequest.vehicleFinancials.AmountFinanced = dealInfo == null ? 0 : dealInfo.amountFinanced;
                rateRequest.vehicleFinancials.DMSDealNumber = dealInfo == null ? null : dealInfo.dmsDealNumber;
                rateRequest.vehicleFinancials.DaysToFirstPayment = dealInfo == null ? null : dealInfo.daysToFirst;
                rateRequest.vehicleFinancials.FinancedAPR = dealInfo == null ? 0 : dealInfo.financeRate;
                rateRequest.vehicleFinancials.FinancedTermMonths = dealInfo == null ? 0 : dealInfo.termMonths;
                rateRequest.vehicleFinancials.FirstPaymentDate = dealInfo == null ? null : dealInfo.firstPaymentDate;
                rateRequest.vehicleFinancials.MSRP = dealInfo == null ? 0 : dealInfo.MSRP;
                rateRequest.vehicleFinancials.MoneyFactor = 0;
                rateRequest.vehicleFinancials.PurchasePrice = dealInfo == null ? 0 : dealInfo.sellingPrice;
                rateRequest.vehicleFinancials.StockNumber = dealInfo == null ? null : dealInfo.stockNumber;
                rateRequest.vehicleFinancials.VehicleSaleType = dealInfo == null ? "RetailFinanced" : dealInfo.saleType;
                rateRequest.vehicleInservice = vehicleInservice ? vehicleInservice.yyyymmdd() : null;
                rateRequest.vehicleOdometer = "" + odometer;
                rateRequest.vehicleToRate.InternalModelId = vehicle.modelId;
                rateRequest.vehicleToRate.VehicleIdentification = vehicle.vin;
                rateRequest.vehicleToRate.InternalMakeId = vehicle.makeId;
                rateRequest.vehicleToRate.ModelYear = vehicle.year;
                rateRequest.vehicleUsageTypes = usageTypes.length == 0 ? null : usageTypes;
                rateRequest.quoteSessionNumber = quoteSession;

                //throw it at the service
                var url = appSettings.startSPANVehicleRateSvcURL + "/RetrieveVehicleRates";
                commonRESTCallService.postToServer(url, rateRequest)
                    .success(function(data, status) {
                        deferred.resolve(data);
                    })
                    .error(function(data, status) {
                        deferred.reject(status + ' ' + data);
                    });

        });

        return deferred.promise;
    };

    //save quote request template (grab from url)
    vehRateService.getRateRequestTemplate = function () {
        var deferred = $q.defer();
        //reducing calls to the server.. this is a "get template" call
        // that always returns the same thing.
        deferred.resolve({"dateOfSale":"","dealerAccountCode":"","eligibilitySessionID":"","partnerSpecificEligibility":null,"productPlanType":null,"productsToRate":[{"CreatedBy":0,"CreatedDate":"\/Date(1453993610227)\/","ID":-2147483648,"LastModifiedDate":"\/Date(1453993610227)\/","ModifiedBy":-2147483648,"PartnerSpecificFields":{"FlexFields":[]},"Abbreviation":null,"ApplicationCode":null,"BaseNoUpgradeProduct":null,"CertificationType":0,"DisplayName":null,"InternalProductId":null,"InternalProductVersionId":null,"InternalRatingProgramId":null,"IsDealerException":false,"IsInserviceRequired":false,"IsNewCoverage":false,"IsVehicleFinancialsRequired":false,"IsWrapCoverage":false,"ParentProductType":null,"PartnerCode":null,"ProductCoverages":[{"CoverageDeductibles":[{"ProductDeductible":{"CreatedBy":0,"CreatedDate":"\/Date(1453993610227)\/","ID":-2147483648,"LastModifiedDate":"\/Date(1453993610227)\/","ModifiedBy":-2147483648,"PartnerSpecificFields":{"FlexFields":[]},"Abbreviation":null,"DisplayName":null,"InternalDeductibleId":null,"NumericValue":null,"PartnerCode":null}}],"ProductCoverage":{"CreatedBy":0,"CreatedDate":"\/Date(1453993610227)\/","ID":-2147483648,"LastModifiedDate":"\/Date(1453993610227)\/","ModifiedBy":-2147483648,"PartnerSpecificFields":{"FlexFields":[]},"Abbreviation":null,"Description":null,"DisplayName":null,"InternalCoverageId":null,"IsLWBaseCoverage":false,"NumericValue":null,"PartnerCode":null},"ProductTerms":null}],"ProductOptions":null,"RateCalculationMethod":0,"SortOrder":null,"UpgradeProducts":[{"CreatedBy":0,"CreatedDate":"\/Date(1453993610227)\/","ID":-2147483648,"LastModifiedDate":"\/Date(1453993610227)\/","ModifiedBy":-2147483648,"PartnerSpecificFields":{"FlexFields":[]},"Abbreviation":null,"ApplicationCode":null,"BaseNoUpgradeProduct":null,"CertificationType":0,"DisplayName":null,"InternalProductId":null,"InternalProductVersionId":null,"InternalRatingProgramId":null,"IsDealerException":false,"IsInserviceRequired":false,"IsNewCoverage":false,"IsVehicleFinancialsRequired":false,"IsWrapCoverage":false,"ParentProductType":null,"PartnerCode":null,"ProductCoverages":null,"ProductOptions":null,"RateCalculationMethod":0,"UpgradesInternalProductId":null}],"UpgradesInternalProductId":null}],"providerCode":"","vehicleCertification":null,"vehicleFinancials":{"AmountFinanced":0,"DMSDealNumber":null,"DaysToFirstPayment":0,"FinancedAPR":0,"FinancedTermMonths":0,"FirstPaymentDate":null,"LenderAddress1":null,"LenderAddress2":null,"LenderCity":null,"LenderCode":null,"LenderEmail":null,"LenderName":null,"LenderPhone":null,"LenderState":null,"LenderZip":null,"MSRP":0,"MoneyFactor":0,"PurchasePrice":0,"StockNumber":null,"VehicleSaleType":"RetailFinanced"},"vehicleInservice":"","vehicleOdometer":"","vehicleToRate":{"InternalMakeId":"","InternalModelId":"","MakeName":"","ModelName":null,"ModelYear":"","VehicleIdentification":null},"vehicleUsageTypes":null, "quoteSessionNumber":null});
/*
        var url = appSettings.startSPANVehicleRateSvcURL + "/VehicleRatesRequestTemplate";
        commonRESTCallService.getFromServer(url)
            .success(function (data, status) {
                deferred.resolve(data);
            })
            .error(function (data, status) {
                deferred.reject(status + ' ' + data);
            });
*/
        return deferred.promise;
    }

    var convertToKeyValuePairs = function(item) {
        if (!item) {
            return [];
        }

        var fieldsArray = [];
        for(var property in item) {
            if(item.hasOwnProperty(property)) {

                var propValue = item[property];
                if(angular.isDate(item[property])) {
                    propValue = propValue.yyyymmdd();
                }

                fieldsArray.push({"key":property, "value": propValue});
            }
        }

        return fieldsArray;
    };

    var mapRVRatingFields= function(rvInfo, eligibleFlexFiels){
        eligibleFlexFiels.push({"key":"rvType", "value": rvInfo.rvType});
        eligibleFlexFiels.push({"key":"rvManuWarrMonths", "value": rvInfo.manuWarrMonths});
        eligibleFlexFiels.push({"key":"rvManuWarrMiles", "value": rvInfo.manuWarrMiles});
        eligibleFlexFiels.push({"key":"rvModelYear", "value": rvInfo.modelYear});
    }

    var mapCustomerEligibilityFields=function(custInfo, eligibleFlexFields){
        eligibleFlexFields.push({"key":"CustomerState", "value": custInfo.state});
        eligibleFlexFields.push({"key":"CustomerZip", "value": custInfo.zip});
    }

    return vehRateService;
}]);
